const getPreviousOffset = (currentOffset, limit) => {
  const previousOffset = currentOffset - Math.abs(limit);
  return previousOffset < 1 ? null : previousOffset;
};

export default getPreviousOffset;
